import { frontendURL } from '../../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

import account from './account/account.routes';
import agent from './agents/agent.routes';
import agentBot from './agentBots/agentBot.routes';
import attributes from './attributes/attributes.routes';
import automation from './automation/automation.routes';
import auditlogs from './auditlogs/audit.routes';
import billing from './billing/billing.routes';
import campaigns from './campaigns/campaigns.routes';
import canned from './canned/canned.routes';
import inbox from './inbox/inbox.routes';
import integrations from './integrations/integrations.routes';
import labels from './labels/labels.routes';
import macros from './macros/macros.routes';
import reports from './reports/reports.routes';
import store from '../../../store';
import sla from './sla/sla.routes';
import teams from './teams/teams.routes';
import customRoles from './customRoles/customRole.routes';
import profile from './profile/profile.routes';

const platformSuperAdminRoutes = routes =>
  routes.map(route => ({
    ...route,
    meta: {
      ...route.meta,
      platformSuperAdminOnly: true,
    },
  }));

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings'),
      name: 'settings_home',
      meta: {
        // Solo administradores. El equipo trabaja desde las páginas del CRM;
        // Ajustes es la zona de fábrica y ahí hay cosas que no deben tocar.
        // Lo que sí necesitan de aquí (las respuestas rápidas) está ahora en
        // Flujos, con el diseño del producto.
        permissions: ['administrator'],
        platformSuperAdminOnly: true,
      },
      redirect: to => {
        if (
          store.getters.getCurrentRole === 'administrator' &&
          store.getters.getCurrentCustomRoleId === null
        ) {
          return { name: 'general_settings_index', params: to.params };
        }

        return { name: 'canned_list', params: to.params };
      },
    },
    ...platformSuperAdminRoutes(account.routes),
    ...agent.routes,
    ...platformSuperAdminRoutes(agentBot.routes),
    ...platformSuperAdminRoutes(attributes.routes),
    ...platformSuperAdminRoutes(automation.routes),
    ...platformSuperAdminRoutes(auditlogs.routes),
    ...platformSuperAdminRoutes(billing.routes),
    ...campaigns.routes,
    ...canned.routes,
    ...inbox.routes,
    ...platformSuperAdminRoutes(integrations.routes),
    ...labels.routes,
    ...macros.routes,
    ...reports.routes,
    ...platformSuperAdminRoutes(sla.routes),
    ...teams.routes,
    ...platformSuperAdminRoutes(customRoles.routes),
    ...profile.routes,
  ],
};
